import { __decorate } from "tslib";
import { AutoEncoder, EnumDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { LoginProviderType } from './User.js';
export class OpenIDClientConfiguration extends AutoEncoder {
    issuer = '';
    clientId = '';
    clientSecret = '';
    /**
     * Best to set this to null to use working defaults
     */
    redirectUri = null;
    static get placeholderClientSecret() {
        return '••••';
    }
}
__decorate([
    field({ decoder: StringDecoder })
], OpenIDClientConfiguration.prototype, "issuer", void 0);
__decorate([
    field({ decoder: StringDecoder })
], OpenIDClientConfiguration.prototype, "clientId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], OpenIDClientConfiguration.prototype, "clientSecret", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, optional: true })
], OpenIDClientConfiguration.prototype, "redirectUri", void 0);
export class OpenIDAuthTokenResponse extends AutoEncoder {
    ssoAuthToken;
}
__decorate([
    field({ decoder: StringDecoder })
], OpenIDAuthTokenResponse.prototype, "ssoAuthToken", void 0);
export class StartOpenIDFlowStruct extends AutoEncoder {
    webshopId = null;
    /**
     * To secure the final redirect (not for the openid connect flow itself)
     */
    spaState;
    /**
     * sso (= use one configured in organization), google, apple, ... (for now only sso supported)
     */
    provider = LoginProviderType.SSO;
    prompt = null;
    redirectUri = null;
    /**
     * Allows to connect an external SSO account to the currently logged in user.
     * To use this, you'll need to request a one-time-usage auth token from /openid/auth-token
     */
    authToken = null;
}
__decorate([
    field({ decoder: StringDecoder, optional: true, nullable: true })
], StartOpenIDFlowStruct.prototype, "webshopId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], StartOpenIDFlowStruct.prototype, "spaState", void 0);
__decorate([
    field({ decoder: new EnumDecoder(LoginProviderType) })
], StartOpenIDFlowStruct.prototype, "provider", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, nullable: true })
], StartOpenIDFlowStruct.prototype, "prompt", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, nullable: true })
], StartOpenIDFlowStruct.prototype, "redirectUri", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, nullable: true })
], StartOpenIDFlowStruct.prototype, "authToken", void 0);
//# sourceMappingURL=OpenID.js.map